import { render } from "./OutCode.vue?vue&type=template&id=83ef7aa6&scoped=true"
import script from "./OutCode.vue?vue&type=script&lang=js"
export * from "./OutCode.vue?vue&type=script&lang=js"

import "./OutCode.vue?vue&type=style&index=0&id=83ef7aa6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83ef7aa6"]])

export default __exports__